
export default {
    routes: [
        {
            path: '',
            name: 'index',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/index'
            },
            component: () => import('@/components/zhgd/index2')
        },
        // {
        //     path: '/index',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/index'
        //     },
        //     component: () => import('@/components/zhgd/index2')
        // },

    ]
}



// WEBPACK FOOTER //
// ./src/router/jianguan.js